var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPiggy(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 20,
    viewBox: "0 0 24 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 2C0 1.46957 0.158035 0.96086 0.43934 0.585787C0.720644 0.210714 1.10218 0 1.5 0H22.5C22.8978 0 23.2794 0.210714 23.5607 0.585787C23.842 0.96086 24 1.46957 24 2V18C24 18.5304 23.842 19.0391 23.5607 19.4142C23.2794 19.7893 22.8978 20 22.5 20H1.5C1.10218 20 0.720644 19.7893 0.43934 19.4142C0.158035 19.0391 0 18.5304 0 18V2ZM4.5 2C4.5 3.06087 4.18393 4.07828 3.62132 4.82843C3.05871 5.57857 2.29565 6 1.5 6V14C2.29565 14 3.05871 14.4214 3.62132 15.1716C4.18393 15.9217 4.5 16.9391 4.5 18H19.5C19.5 16.9391 19.8161 15.9217 20.3787 15.1716C20.9413 14.4214 21.7044 14 22.5 14V6C21.7044 6 20.9413 5.57857 20.3787 4.82843C19.8161 4.07828 19.5 3.06087 19.5 2H4.5Z",
    fill: "#467B3E"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPiggy);
export default __webpack_public_path__ + "static/media/piggy.1a83bf872e636648b1c9b330475c9086.svg";
export { ForwardRef as ReactComponent };